import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { IS_APP_PRODUCTION, PACKAGE_NAME } from "../../environment";

const characterList = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const CookieList = ["accessToken", "refreshToken"];

// * Token login controls
export function generateCookiesName() {
  let secretCode = 10;
  for (let i = 0; i < PACKAGE_NAME.length; i++) {
    secretCode += PACKAGE_NAME.charCodeAt(i) * PACKAGE_NAME.length;
  }

  secretCode = Math.round(secretCode / PACKAGE_NAME.length);
  let GeneratedCookiesName = {};
  CookieList.forEach((cookie) => {
    let tempCookieString = "";
    for (let j = 0; j < cookie.length; j++) {
      let charCode = Math.floor((cookie.charCodeAt(j) * characterList.length * cookie.length) / secretCode);
      charCode = charCode > characterList.length ? charCode - characterList.length : charCode;
      tempCookieString += characterList.charAt(Math.floor(charCode));
    }

    GeneratedCookiesName[cookie] = tempCookieString;
  });
  return GeneratedCookiesName;
}

export function generatePredictableUniqueKeyName(key) {
  let secretCode = 10;
  for (let i = 0; i < PACKAGE_NAME.length; i++) {
    secretCode += PACKAGE_NAME.charCodeAt(i) * PACKAGE_NAME.length;
  }

  secretCode = Math.round(secretCode / PACKAGE_NAME.length);
  let uniqueKeyString = "";
  for (let j = 0; j < key.length; j++) {
    let charCode = Math.floor((key.charCodeAt(j) * characterList.length * key.length) / secretCode);
    charCode = charCode > characterList.length ? charCode - characterList.length : charCode;
    uniqueKeyString += characterList.charAt(Math.floor(charCode));
  }
  return uniqueKeyString;
}

export const generatedCookies = generateCookiesName();
export const storage = IS_APP_PRODUCTION
  ? {
      getToken: () => Cookies.get(generatedCookies.accessToken) && CryptoJS.AES.decrypt(Cookies.get(generatedCookies.accessToken), PACKAGE_NAME).toString(CryptoJS.enc.Utf8),
      setToken: (token) => Cookies.set(generatedCookies.accessToken, CryptoJS.AES.encrypt(token, PACKAGE_NAME).toString(), { secure: true, path: IS_APP_PRODUCTION ? `/` : `/${PACKAGE_NAME}`, expires: 0.5 }),
      clearToken: () => Cookies.remove(generatedCookies.accessToken, { path: IS_APP_PRODUCTION ? `/` : `/${PACKAGE_NAME}` }),
      setSessionStorage: (key, value) => window.sessionStorage.setItem(generatePredictableUniqueKeyName(key), JSON.stringify(value)),
      getSessionStorage: (key) => window.sessionStorage.getItem(generatePredictableUniqueKeyName(key)) && JSON.parse(window.sessionStorage.getItem(generatePredictableUniqueKeyName(key))),
    }
  : {
      getToken: () => window.localStorage.getItem(generatedCookies.accessToken) && CryptoJS.AES.decrypt(window.localStorage.getItem(generatedCookies.accessToken), PACKAGE_NAME).toString(CryptoJS.enc.Utf8),
      setToken: (token) => window.localStorage.setItem(generatedCookies.accessToken, CryptoJS.AES.encrypt(token, PACKAGE_NAME).toString()),
      clearToken: () => window.localStorage.removeItem(generatedCookies.accessToken),
      setSessionStorage: (key, value) => window.sessionStorage.setItem(generatePredictableUniqueKeyName(key), JSON.stringify(value)),
      getSessionStorage: (key) => window.sessionStorage.getItem(generatePredictableUniqueKeyName(key)) && JSON.parse(window.sessionStorage.getItem(generatePredictableUniqueKeyName(key))),
    };
